// extracted by mini-css-extract-plugin
export default {"Container":"playcard_Container__dl3CE","image":"playcard_image__d2Syr","title":"playcard_title__Q9614","value":"playcard_value__JmKzT","selectImage":"playcard_selectImage__Pa+K-"};